export default __webpack_public_path__ + "static/media/arrow-down_gray.496510ef.svg";